import { render } from "./EditRoom.vue?vue&type=template&id=d7862160&ts=true"
import script from "./EditRoom.vue?vue&type=script&lang=ts"
export * from "./EditRoom.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__